import { defineComponent as _defineComponent } from 'vue'
import ScrollingText from "@/components/common/ScrollingText.vue";
import TickingTime from "@/components/common/TickingTime.vue";

import SideNav from "@/components/layout/SideNav.vue";

import { useRootStore } from "@/store/pinia";
import { computed, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { useQuery } from "@vue/apollo-composable";
import { LanguageLocale, SUPPORTED_LANGUAGES, useTranslation } from "@/store/translation";
import { queries } from "@/apollo";
import { useScrollingTextQuery } from "@/api/settingsQueries";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const store = useRootStore();
const translation = useTranslation();
const appMode = computed(() => useRootStore().appMode);

const { result: systemTimeResult } = useQuery<{ systemTime: string }>(
  queries.systemTime,
  {},
  { fetchPolicy: "cache-first" }
);
const { data: scrollingTextResult } = useScrollingTextQuery(appMode);

const result = computed(() => ({
  systemTime: systemTimeResult.value?.systemTime,
  scrollingText: scrollingTextResult.value,
}));

const showSideNav = ref(false);

const router = useRouter();

function logout() {
  useRootStore().logout();
  // this.$store.dispatch("logout");
  router.push({ name: "login" });
}

function toggleSideNav() {
  showSideNav.value = !showSideNav.value;
}

function handleMenuClick() {
  showSideNav.value = false;
}

function changeLang(locale: LanguageLocale) {
  useTranslation().setLanguage(locale);
}
// }

return { __sfc: true,store, translation, appMode, systemTimeResult, scrollingTextResult, result, showSideNav, router, logout, toggleSideNav, handleMenuClick, changeLang, ScrollingText, TickingTime, SideNav, SUPPORTED_LANGUAGES }
}

})